import { getApiClient } from '@/api-client/api-client';
import { AccountDto } from '@/api-client/autogenerated';

export const getMyAccounts = async (): Promise<AccountDto[]> => {
  const res = await getApiClient().getMyAccounts();
  return res.data;
};

export const updateAIStrength = async (aiStrength: 'High' | 'Medium' | 'Low' | null) => {
  const res = await getApiClient().updateAIStrength({
    updateAIStrengthRequest: { aiStrength },
  });
  return res.data;
};

export const updateCommitteeAgentEnabled = async (enabled: boolean) => {
  const res = await getApiClient().updateCommitteeAgentEnabled({
    updateCommitteeAgentEnabledRequest: { enabled },
  });
  return res.data;
};
